const BUILTIN_PICTOS = new Set(["nouveautes", "robes", "hauts", "accessoires"]);

export function categoryImage(cat) {
  if (!cat) return null;
  if (cat.image_url) return cat.image_url;
  if (cat.slug && BUILTIN_PICTOS.has(cat.slug)) return `/categories/${cat.slug}.png`;
  return null;
}
